import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { DayOfWeek } from '../../../enums/DayOfWeek';
import { StoreWorkingTime } from '../../../models/store/StoreWorkingTime';
import { StoreDefaultWorkingTime } from '../../../models/store/StoreDefaultWorkingTime';
import { StoreDefaultWorkingHoursResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store default working time HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreDefaultWorkingTimeAdapter implements Adapter<StoreDefaultWorkingTime[]> {

  /**
   * Converts store default working time HTTP response to a list of {@link StoreDefaultWorkingTime}.
   * @param item store default working time HTTP response.
   */
  adapt(item: StoreDefaultWorkingHoursResponse[]): StoreDefaultWorkingTime[] {
    const defaultWorkingTimes: StoreDefaultWorkingTime[] = [];
    if (!item) {
      return defaultWorkingTimes;
    }

    item.map($item => {
      const weeklyTimes = new Map<DayOfWeek, StoreWorkingTime>();
      weeklyTimes.set(DayOfWeek.MONDAY, new StoreWorkingTime($item.monday.openingTime, $item.monday.closingTime));
      weeklyTimes.set(DayOfWeek.TUESDAY, new StoreWorkingTime($item.tuesday.openingTime, $item.tuesday.closingTime));
      weeklyTimes.set(DayOfWeek.WEDNESDAY, new StoreWorkingTime($item.wednesday.openingTime, $item.wednesday.closingTime));
      weeklyTimes.set(DayOfWeek.THURSDAY, new StoreWorkingTime($item.thursday.openingTime, $item.thursday.closingTime));
      weeklyTimes.set(DayOfWeek.FRIDAY, new StoreWorkingTime($item.friday.openingTime, $item.friday.closingTime));
      weeklyTimes.set(DayOfWeek.SATURDAY, new StoreWorkingTime($item.saturday.openingTime, $item.saturday.closingTime));
      weeklyTimes.set(DayOfWeek.SUNDAY, new StoreWorkingTime($item.sunday.openingTime, $item.sunday.closingTime));
      defaultWorkingTimes.push(new StoreDefaultWorkingTime($item.date, weeklyTimes));
    });
    return defaultWorkingTimes.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
